import { CompartmentCard } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import { UploadCards } from "@/src/components/uploadSpots";
import { Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { useState } from "react";

export function UploadsHistory({ patient }: { patient: Patient }) {
  const [reload, setReload] = useState(0);
  return (
    <CompartmentCard title={"uploads"} color="blue" onClick={async () => {}}>
      <FetchableList
        queryKey={["UploadsHistory", patient.id, reload]}
        queryFn={() =>
          apiFetch("uploads", "loadMany", {
            patientId: patient.id,
          })
        }
      >
        {(data) => (
          <UploadCards
            uploads={data || []}
            count={3}
            onDelete={(upload) => {
              setReload(reload + 1);
            }}
          />
        )}
      </FetchableList>
    </CompartmentCard>
  );
}
